export default [
    {
        id: 2,
        parentId: 1,
        label: "首页",
        path: "/home",
        icon: 'el-icon-s-home',
        permission: 'index',
        component: 'Layout',
        type: 'M',
    },
    {
        id: 1,
        component: 'workJob',
        label: "工作台",
        path: "/Stag",
        icon: 'el-icon-s-platform',
    },
    // 目录
    {
        id: 3,
        parentId: 2,
        label: "目录",
        path: "/acc",
        permission: 'menu',
        icon: 'el-icon-menu',
        component: 'Layout',
        type: 'C',
        children: [
            {
                id: 14,
                label: "调试工具",
                path: "/Acc/tool",
                icon: 'el-icon-tsgj',
                permission: 'tool',
                children: [
                    {
                        id: 15,
                        label: "诊疗收费",
                        path: "/charge/charge",
                        icon: 'el-icon-coin',
                    },
                    {
                        id: 16,
                        label: "结班管理",
                        path: "/charge/Closing",
                        icon: 'el-icon-video-play',
                        permission: 'Closing',
                    }
                ]
            },
            {
                id: 17,
                label: "科室床位",
                path: "/Acc/bed",
                icon: 'el-icon-kscw',
                permission: 'bed',
                children: [
                    {
                        id: 18,
                        label: "诊疗收费",
                        path: "/charge/charge",
                        icon: 'el-icon-coin',
                    },
                    {
                        id: 19,
                        label: "结班管理",
                        path: "/charge/Closing",
                        icon: 'el-icon-video-play',
                    }
                ]
            },
            {
                id: 20,
                label: "人员相关",
                path: "/Acc/acc-list",
                icon: 'el-icon-dangan',
                children: []
            },
            {
                id: 21,
                label: "西药相关",
                path: "/Acc/xcy",
                icon: 'el-icon-xy',
                children: []
            },
            {
                id: 22,
                label: "中药相关",
                path: "/Acc/zcy",
                icon: 'el-icon-zhongcaoyao',
                children: []
            },
        ]
    },
    {
        id: 4,
        parentId: 3,
        label: "门诊",
        path: "/reservation",
        icon: 'el-icon-menzhen',
        type: 'M',
        children: [
            {
                id: 23,
                label: "挂号类别",
                path: "/reservation/category",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 77,
                label: "坐诊",
                path: "/reservation/clinicSchedule",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 78,
                label: "挂号",
                path: "/reservation/reservation",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 79,
                label: "合约单位",
                path: "/customer/contractDept",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 80,
                label: "挂号列表",
                path: "/reservation/reservationList",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 81,
                label: "门诊医师",
                path: "/reservation/outpatientPhysician",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 82,
                label: "病历模板",
                path: "/reservation/caseHistoryTemplate",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 83,
                label: "门诊收费",
                path: "/reservation/outpatientCharge",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 83,
                label: "挂账类型",
                path: "/reservation/onCreditType",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 84,
                label: "收费列表",
                path: "/reservation/outpatientChargeList",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 86,
                label: "门诊护士",
                path: "/reservation/outpatientNurse",
                icon: 'el-icon-ghlb',
                children: []
            },
            {
                id: 87,
                label: "医保日志",
                path: "/ybRecord/ybRecordLog",
                icon: 'el-icon-tsgj',
                children: []
            },
            {
                id: 89,
                label: "医保关键字",
                path: "/reservation/seedoctorKeyword/seedoctorKeyword",
                icon: 'el-icon-tsgj',
                children: []
            },
            {
                id: 90,
                label: "西药处方列表",
                path: "/reservation/westernMedicineList/westernMedicineList",
                icon: 'el-icon-tsgj',
                children: []
            },
            {
                id: 91,
                label: "中药处方列表",
                path: "/reservation/chinaMedicineList/chinaMedicineList",
                icon: 'el-icon-tsgj',
                children: []
            },
            {
                id: 24,
                label: "收费项目",
                path: "/reservation/charge",
                icon: 'el-icon-sfxm',
                children: []
            },
            {
                id: 24,
                label: "项目价格",
                path: "/reservation/charge",
                icon: 'el-icon-sfxm',
                children: []
            },
            {
                id: 25,
                label: "健康档案",
                path: "/reservation/Healthrecords",
                icon: 'el-icon-dangan',
                children: []
            },
            {
                id: 26,
                label: "坐诊管理",
                path: "/reservation/Siting",
                icon: 'el-icon-zzgl',
                children: []
            },
            {
                id: 27,
                label: "坐诊排班",
                path: "/reservation/Scheduling",
                icon: 'el-icon-zzpb',
                children: []
            },
        ]
    },
    {
        id: 5,
        parentId: 4,
        label: "公共目录",
        path: "/MedicenCata",
        icon: 'el-icon-document',
        type: 'M',
        children: [
            {
                id: 141,
                label: "打印模板",
                path: "/PrintTemplateDesigner",
                icon: 'el-icon-ggml',
                children: []
            },
            {
                id: 28,
                label: "行政区域",
                path: "/systemCatalogue/area",
                icon: 'el-icon-xzqy',
                children: []
            },
            {
                id: 29,
                label: "机构列表",
                path: "/systemCatalogue/institution",
                icon: 'el-icon-jglb',
                children: []
            },
            {
                id: 30,
                label: "院区列表",
                path: "/systemCatalogue/CampusAreas",
                icon: 'el-icon-yqlb',
                children: []
            },
            {
                id: 31,
                label: "临床科别",
                path: "/systemCatalogue/ClinicalDepartment",
                icon: 'el-icon-lcks',
                children: []
            },
            {
                id: 32,
                label: "人员相关",
                path: "/systemCatalogue/PersonnelRelated",
                icon: 'el-icon-dangan',
            },
            {
                id: 139,
                label: "供货单位",
                path: "/supplier",
                icon: 'el-icon-blsjxj',
            },
			{
			    id: 148,
			    label: "科室管理",
			    path: "/deptAbout",
			    icon: 'el-icon-tnzdsj',
			},
			{
			    id: 151,
			    label: "科室设置",
			    path: "/deptAbout",
			    icon: 'el-icon-tnzdsj',
			},
			{
			    id: 152,
			    label: "成员管理",
			    path: "/Acc/acc-list",
			    icon: 'el-icon-dangan',
			    children: []
			},
			{
			    id: 153,
			    label: "证件管理",
			    path: "/cardClinic",
			    icon: 'el-icon-dangan',
			    children: []
			},
			{
			    id: 149,
			    label: "卫材目录",
			    path: "/reservation/Eisai",
			    icon: 'el-icon-bzdw',
			},
            {
                id: 33,
                label: "西成药品",
                path: "/systemCatalogue/xicheng/Dictionaries",
                icon: 'el-icon-xy',
                children: [
                    {
                        id: 60,
                        label: "西药目录",
                        path: "/systemCatalogue/xicheng/XichengMedicine",
                        icon: 'el-icon-xy',
                    },
                    // {
                    //     id: 73,
                    //     label: "优化西药目录",
                    //     path: "/systemCatalogue/Western/Western",
                    //     icon: 'el-icon-xy',
                    // },
                    {
                        id: 74,
                        label: "药品加成率",
                        path: "/systemCatalogue/markUp",
                        icon: 'el-icon-byj',
                    },
                    {
                        id: 62,
                        label: "包装单位",
                        path: "/systemCatalogue/xicheng/packing",
                        icon: 'el-icon-bzdw',
                    },
                    {
                        id: 63,
                        label: "计量单位",
                        path: "/systemCatalogue/xicheng/metering",
                        icon: 'el-icon-jldw',
                    },
                    {
                        id: 64,
                        label: "剂量单位",
                        path: "/systemCatalogue/xicheng/dose",
                        icon: 'el-icon-jl',
                    },
                    {
                        id: 65,
                        label: "药品剂型",
                        path: "/systemCatalogue/xicheng/Dosage",
                        icon: 'el-icon-cflx',
                    },
                    {
                        id: 66,
                        label: "药理类别",
                        path: "/systemCatalogue/xicheng/Pharmacological",
                        icon: 'el-icon-yllb',
                    },
                    {
                        id: 67,
                        label: "处方类型",
                        path: "/systemCatalogue/xicheng/prescription",
                        icon: 'el-icon-chufang',
                    },
                    {
                        id: 68,
                        label: "毒麻类型",
                        path: "/systemCatalogue/xicheng/Poisonous",
                        icon: 'el-icon-dml',
                    },
                    {
                        id: 69,
                        label: "贵重类型",
                        path: "/systemCatalogue/xicheng/precious",
                        icon: 'el-icon-gz',

                    },
                    {
                        id: 70,
                        label: "中标等级",
                        path: "/systemCatalogue/xicheng/WinningTheBidgrades",
                        icon: 'el-icon-bazi',
                    },
                    {
                        id: 71,
                        label: "临床用途",
                        path: "/systemCatalogue/xicheng/clinical",
                        icon: 'el-icon-lcyt',

                    },
                    {
                        id: 72,
                        label: "药品分类限制",
                        path: "/systemCatalogue/xicheng/classlimit",
                        icon: 'el-icon-flxz',
                    },
                ]
            },
            {
                id: 104,
                label: "中草药品",
                path: "/systemCatalogue/traMedici",
                icon: 'el-icon-zyyp',
                children: [
                    {
                        id: 105,
                        label: "中药目录",
                        path: "/systemCatalogue/traMedici",
                        icon: 'el-icon-zyyp',
                    },
                ]
            },
            {
                id: 99,
                label: "系统参数",
                path: "/systemCatalogue/systemParameter",
                icon: 'el-icon-dangan',
            },
            {
                id: 35,
                label: "卫生材料",
                path: "/systemCatalogue/HygienicMaterials",
                icon: 'el-icon-weisheng',
            },
            {
                id: 88,
                label: "给药方式对照",
                path: "/systemCatalogue/cosrute",
                icon: 'el-icon-dangan',
            },
        ]
    },
    // 药房
    {
        id: 126,
        parentId: 126,
        label: "药房",
        path: "/medicenHouse",
        icon: 'el-icon-document',
        type: 'M',
        children: [
            // 西药房
            {
                id: 127,
                label: "西药房",
                path: "/medicenHouse/WesternHouse",
                icon: 'el-icon-xy',
                children: [
                    {
                        id: 128,
                        label: "西药房库存",
                        path: "/medicenHouse/WesternHouse/WesternHouseStore",
                        icon: 'el-icon-navicon-kcz',
                    },
                    {
                        id: 133,
                        label: "西药房其他入库",
                        path: "/medicenHouse/WesternHouse/OhtersInstore",
                        icon: 'el-icon-navicon-export',
                    },
                    {
                        id: 134,
                        label: "西药房其他出库",
                        path: "/medicenHouse/WesternHouse/OthersReturn",
                        icon: 'el-icon-navicon-export',
                    },
                    {
                        id: 161,
                        label: "药品盘点",
                        path: "/PSI/inventoryPsi",
                        icon: 'el-icon-navicon-blsjxj',
                    },
                    {
                        id: 132,
                        label: "西药房库存预警",
                        path: "/medicenHouse/WesternHouse/deptUseWarning",
                        icon: 'el-icon-navicon-gz',
                    },
                    {
                        id: 138,
                        label: "西药房效期预警",
                        path: "/medicenHouse/WesternHouse/ValidityPeriod",
                        icon: 'el-icon-lcyt',
                    },
                    {
                        id: 142,
                        label: "西药房盘点",
                        path: "/medicenHouse/WesternHouse/WesterHouseCount",
                        icon: 'el-icon-lcyt',
                    },
                    {
                        id: 142,
                        label: "西药房发药",
                        path: "/medicenHouse/WesternHouse/giveMedici",
                        icon: 'el-icon-lcyt',
                    },
                    {
                        id: 144,
                        label: "西药房退药",
                        path: "/medicenHouse/WesternHouse/returnMedici",
                        icon: 'el-icon-lcyt',
                    },
                ]
            },
            // 中药房
            {
                id: 129,
                label: "中药房",
                path: "/medicenHouse/traMediciHouse",
                icon: 'el-icon-zy',
                children: [
                    {
                        id: 130,
                        label: "中药房库存",
                        path: "/medicenHouse/traMediciHouse/traMediciHouseStore",
                        icon: 'el-icon-navicon-kcz',
                    },
                    {
                        id: 135,
                        label: "中药房其他入库",
                        path: "/medicenHouse/traMediciHouse/OthersInstore",
                        icon: 'el-icon-navicon-export',
                    },
                    {
                        id: 136,
                        label: "中药房其他出库",
                        path: "/medicenHouse/traMediciHouse/OthersReturn",
                        icon: 'el-icon-navicon-export',
                    },
                    {
                        id: 137,
                        label: "库存预警",
                        path: "/medicenHouse/traMediciHouse/deptUseWarning",
                        icon: 'el-icon-navicon-gz',
                    },
                    {
                        id: 143,
                        label: "中药房盘点",
                        path: "/medicenHouse/WesternHouse/traMediciHouseCount",
                        icon: 'el-icon-lcyt',
                    },
                    {
                        id: 145,
                        label: "中药房发药",
                        path: "/medicenHouse/traMediciHouse/giveMedici",
                        icon: 'el-icon-lcyt',
                    },
                    {
                        id: 146,
                        label: "中药房退药",
                        path: "/medicenHouse/traMediciHouse/returnMedici",
                        icon: 'el-icon-lcyt',
                    },
                ]
            },
        ],
    },

    {
        id: 6,
        parentId: 5,
        label: "库存管理",
        path: "/PSI",
        icon: 'el-icon-notebook-2',
        permission: 'PSI',
        type: 'M',
        children: [
            {
                id: 106,
                label: "西药采购",
                path: "/systemCatalogue/traditional-Chinese-medicine/traditional-Chinese-medicine",
                icon: 'el-icon-zyyp',
                children: [
                    {
                        id: 36,
                        label: "西药采购计划",
                        path: "/PSI",
                        icon: 'el-icon-shopping-cart-2',
                        permission: 'PSI',
                    },
					{
					    id: 166,
					    label: "库存相关",
					    path: "/PSI/StorePsi",
					    icon: 'el-icon-shopping-cart-2',
					    permission: 'PSI',
					},
                    {
                        id: 37,
                        label: "西药采购入库",
                        path: "/PSI/shopStore",
                        icon: 'el-icon-s-platform',
                        permission: 'shopStore',
                    },
                    {
                        id: 140,
                        label: "西药库库存盘点",
                        path: "/PSI/InventoryCount",
                        icon: 'el-icon-s-platform',
                    },
                    {
                        id: 131,
                        label: "西药其他入库",
                        path: "/PSI/putOthersInstore",
                        icon: 'el-icon-chufang',
                        permission: 'putOthersInstore',
                    },
                    {
                        id: 132,
                        label: "西药库零售调价",
                        path: "/PSI/WesternPriceChance",
                        icon: 'el-icon-xdj',
                        permission: 'WesternPriceChance',
                    },
                    {
                        id: 61,
                        label: "西药药房申领",
                        path: "/PSI/application",
                        icon: 'el-icon-gz',
                        permission: 'application',
                    },
                    {
                        id: 124,
                        label: "西药药品调拨",
                        path: "/PSI/allocate",
                        icon: 'el-icon-refresh',
                        permission: 'PSI',
                    },
                    {
                        id: 38,
                        label: "西药结算清单",
                        path: "/PSI/PSIOrder",
                        icon: 'el-icon-shopping-bag-2',
                        permission: 'PSIOrder',
                    },
                    {
                        id: 39,
                        label: "西药采购退货",
                        path: "/PSI/shopReturn",
                        icon: 'el-icon-s-check',
                    },
                    {
                        id: 40,
                        label: "西药处方发药",
                        path: "/PSI/shopDispensing",
                        icon: 'el-icon-s-shop',
                    },
                    {
                        id: 41,
                        label: "西药处方管理",
                        path: "/PSI/shopMangnier",
                        icon: 'el-icon-shopping-bag-1',
                    },
                    {
                        id: 42,
                        label: "西药处方退药",
                        path: "/PSI/shopBack",
                        icon: 'el-icon-s-platform',

                    },
                    {
                        id: 43,
                        label: "库存预警",
                        path: "/PSI/warnStore",
                        icon: 'el-icon-s-check',
                    },
                    {
                        id: 44,
                        label: "西药药品库存",
                        path: "/PSI/storeManger",
                        icon: 'el-icon-s-shop',
                    },
                    {
                        id: 99,
                        label: "西药变化明细表",
                        path: "/PSI/ChangeDetailsTable",
                        icon: 'el-icon-menu',
                    },
                    {
                        id: 45,
                        label: "西药效期管理",
                        path: "/PSI/periodManger",
                        icon: 'el-icon-shopping-bag-1',
                    },
                    {
                        id: 46,
                        label: "西药追溯码管理",
                        path: "/PSI/TraceabilityCode",
                        icon: 'el-icon-shopping-bag-1',
                    },
                ]
            },
            {
                id: 107,
                label: "中药采购",
                path: "/PSI/traMediciplan",
                icon: 'el-icon-zyyp',
                children: [
                    {
                        id: 108,
                        label: "中药采购计划",
                        path: "/PSI/traMediciplan",
                        icon: 'el-icon-shopping-cart-2',
                        commpent: 'Tra',
                        permission: 'Tra',
                        // systemAdd: "system:tra:add"
                    },
                    {
                        id: 109,
                        label: "中药采购入库",
                        path: "/PSI/traMediciInstore",
                        icon: 'el-icon-s-platform',
                        permission: 'TraStore',
                    },
					{
					    id: 150,
					    label: "中药其他入库",
					    path: "/PSI/traMediciOthersInstore",
					    icon: 'el-icon-chufang',
					    permission: 'traMediciOthersInstore',
					},
                    {
                        id: 110,
                        label: "中药药房申领",
                        path: "/PSI/traMediciPharmacy",
                        icon: 'el-icon-zy',
                        permission: 'traMediciPharmacy',
                    },
                    {
                        id: 143,
                        label: "中药库库存盘点",
                        path: "/PSI/traMediciCount",
                        icon: 'el-icon-s-platform',
                    },
                    {
                        id: 111,
                        label: "中药结算清单",
                        path: "/PSI/PSIOrder",
                        icon: 'el-icon-shopping-bag-2',
                        permission: 'PSIOrder',
                    },
                    {
                        id: 112,
                        label: "中药采购退货",
                        path: "/PSI/traMediciReturn",
                        icon: 'el-icon-s-check',
                    },
                    {
                        id: 125,
                        label: "中药药品调拨",
                        path: "/PSI/allocate",
                        icon: 'el-icon-refresh',
                        permission: 'PSI',
                    },
                    {
                        id: 113,
                        label: "中药处方发药",
                        path: "/PSI/shopDispensing",
                        icon: 'el-icon-s-shop',
                    },
                    {
                        id: 114,
                        label: "中药处方管理",
                        path: "/PSI/shopMangnier",
                        icon: 'el-icon-shopping-bag-1',
                    },
                    {
                        id: 115,
                        label: "中药处方退药",
                        path: "/PSI/shopBack",
                        icon: 'el-icon-s-platform',

                    },
                    {
                        id: 116,
                        label: "中药预警管理",
                        path: "/PSI/warnManger",
                        icon: 'el-icon-s-check',
                    },
                    {
                        id: 117,
                        label: "中药药品库存",
                        path: "/PSI/storeManger",
                        icon: 'el-icon-s-shop',
                    },
                    {
                        id: 118,
                        label: "中药变化明细表",
                        path: "/PSI/ChangeDetailsTable",
                        icon: 'el-icon-menu',
                    },
                    {
                        id: 119,
                        label: "中药效期管理",
                        path: "/PSI/periodManger",
                        icon: 'el-icon-shopping-bag-1',
                    },
                    {
                        id: 120,
                        label: "中药追溯码管理",
                        path: "/PSI/TraceabilityCode",
                        icon: 'el-icon-shopping-bag-1',
                    },
                    {
                        id: 121,
                        label: "中药药品调拨",
                        path: "/PSI/traMediciAllocate",
                        icon: 'el-icon-refresh',
                    },
                    {
                        id: 122,
                        label: "中药库存一览表",
                        path: "/PSI/inventoryTable",
                        icon: 'el-icon-kucun',
                    },
                    {
                        id: 123,
                        label: "中药流向明细表",
                        path: "/PSI/flowTable",
                        icon: 'el-icon-kucun',
                    },
                ]
            },


        ]
    },
    {
        id: 7,
        parentId: 6,
        label: "移动支付",
        path: "/PayforMedicen/PayforScheduling",
        icon: 'el-icon-wallet',
        type: 'M',
        children: [
            {
                id: 47,
                label: "预约挂号",
                path: "/PayforMedicen/PayforScheduling",
                icon: 'el-icon-tickets',
            },
            {
                id: 48,
                label: "诊所诊间",
                path: "/PayforMedicen/PayforRoom",
                icon: 'el-icon-circle-plus',
            },
            {
                id: 49,
                label: "聚合支付",
                path: "/PayforMedicen/thirdpartyPayment",
                icon: 'el-icon-edit',
            },
            {
                id: 85,
                label: "支付订单",
                path: "/PayforMedicen/payOrder",
                icon: 'el-icon-edit',
            },
        ]
    },
    {
        id: 8,
        parentId: 7,
        label: "诊疗工作站",
        path: "/Stag",
        icon: 'el-icon-s-cooperation',
        children: [
            {
                id: 50,
                label: "医生工作站",
                path: "/Stag/DocStag",
                icon: 'el-icon-tickets',
            },
            {
                id: 51,
                label: "治疗工作站",
                path: "/Stag/HealStag",
                icon: 'el-icon-circle-plus',
            },
            {
                id: 52,
                label: "门诊病历系统",
                path: "/Stag/OutpatStag",
                icon: 'el-icon-edit',
            },
            {
                id: 53,
                parentId: 52,
                label: "一体化工作站",
                path: "/Stag/industrialStag",
                icon: 'el-icon-edit',
            },
        ]
    },

    {
        id: 9,
        parentId: 8,
        label: "患者管理",
        path: "/files",
        icon: 'el-icon-postcard',
        type: 'M',
        children: [
            {
                id: 54,
                parentId: 53,
                label: "基本信息",
                path: "/files/files",
                icon: 'el-icon-tickets',
            },
            {
                id: 55,
                parentId: 54,
                label: "患者充值",
                path: "/files/Recharge",
                icon: 'el-icon-tickets',
            },
            {
                id: 56,
                parentId: 55,
                label: "患者回访",
                path: "/files/visited",
                icon: 'el-icon-circle-plus',
            },
            {
                id: 57,
                parentId: 56,
                label: "优惠活动",
                path: "/files/activity",
                icon: 'el-icon-edit',
            },
        ]
    },

    // 收费管理
    {
        id: 10,
        parentId: 9,
        label: "收费管理",
        path: "/charge",
        icon: 'el-icon-coin',
        type: 'M',
        children: [
            {
                id: 58,
                parentId: 57,
                label: "诊疗收费",
                path: "/charge/charge",
                icon: 'el-icon-coin',
            },
            {
                id: 59,
                parentId: 58,
                label: "结班管理",
                path: "/charge/Closing",
                icon: 'el-icon-video-play',
            }
        ]
    },

    {
        id: 11,
        parentId: 10,
        label: "工作台",
        path: "/workJob",
        icon: 'el-icon-s-platform',
        type: 'M',
    },
    {
        id: 12,
        parentId: 11,
        label: "诊所管理",
        path: "/Shop",
        icon: 'el-icon-s-shop',
        type: 'M',
    },
    {
        id: 13,
        parentId: 12,
        label: "订单管理",
        path: "/Order",
        icon: 'el-icon-shopping-bag-1',
        type: 'M',
    }
]

